
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { PolicyType } from '../types/PolicyTypes';

interface GeneralPolicySectionProps {
  policy: PolicyType;
  setPolicy: React.Dispatch<React.SetStateAction<PolicyType>>;
  isEditing: boolean;
}

const GeneralPolicySection = ({ policy, setPolicy, isEditing }: GeneralPolicySectionProps) => {
  return (
    <div>
      <h3 className="text-lg font-medium mb-4">General Investment Parameters</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="maxSingleExposure">Maximum Single Institution Exposure (%)</Label>
          <Input 
            id="maxSingleExposure" 
            type="number" 
            value={policy.general.maxSingleInstitutionExposure} 
            onChange={(e) => setPolicy({
              ...policy,
              general: {
                ...policy.general,
                maxSingleInstitutionExposure: parseFloat(e.target.value)
              }
            })}
            disabled={!isEditing}
          />
          <p className="text-sm text-muted-foreground">
            Maximum percentage of total investments allowed in a single institution
          </p>
        </div>
        <div className="space-y-2">
          <Label htmlFor="minLiquidity">Minimum Liquidity Buffer (%)</Label>
          <Input 
            id="minLiquidity" 
            type="number" 
            value={policy.general.minimumLiquidityBuffer} 
            onChange={(e) => setPolicy({
              ...policy,
              general: {
                ...policy.general,
                minimumLiquidityBuffer: parseFloat(e.target.value)
              }
            })}
            disabled={!isEditing}
          />
          <p className="text-sm text-muted-foreground">
            Percentage of funds that must remain in highly liquid instruments
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Switch 
            id="twoLevelApproval"
            checked={policy.general.requireTwoLevelApproval}
            onCheckedChange={(checked) => setPolicy({
              ...policy,
              general: {
                ...policy.general,
                requireTwoLevelApproval: checked
              }
            })}
            disabled={!isEditing}
          />
          <Label htmlFor="twoLevelApproval">Require Two-Level Approval for Investments</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Switch 
            id="autoReinvest"
            checked={policy.general.autoReinvestMaturity}
            onCheckedChange={(checked) => setPolicy({
              ...policy,
              general: {
                ...policy.general,
                autoReinvestMaturity: checked
              }
            })}
            disabled={!isEditing}
          />
          <Label htmlFor="autoReinvest">Automatically Reinvest on Maturity</Label>
        </div>
      </div>
    </div>
  );
};

export default GeneralPolicySection;
